const initialState = {
  eventDetails: {},
  smpId: null,
  eventMetaDetails: {},
  dashboard: {},
  attendeesList: [],
  attendeesTableData: {
    'page_no': 1,
    'page_size': 10,
    'total_pages': 1,
    'total_elements': 10,
    'is_last': true,
    'is_first': true,
  },
  priceBreakups: {},
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'ADMIN_PRIMARY_EVENT_EDIT:EVENT_DATA:SET':
    return {
      ...state,
      eventDetails: data.eventDetails,
      eventMetaDetails: data.eventMetaDetails,
      smpId: data.smpId,
      mongoId: data.mongoId || state.mongoId,
    };
  case 'ADMIN_PRIMARY_EVENT_EDIT:DASHBOARD_DATA:SET':
    return {
      ...state,
      dashboard: data,
    };
  case 'ADMIN_PRIMARY_EVENT_EDIT:ATTENDEES_LIST:SET':
    return {
      ...state,
      attendeesList: data.attendeesList,
      attendeesTableData: data.pagination,
    };
  case 'ADMIN_PRIMARY_EVENT_EDIT:PRICE_BREAKUP:SET':
    return {
      ...state,
      priceBreakups: { ...state.priceBreakups, [action.price]: data },
    };
  default:
    return state;
  }
}